import { useQueryClient } from '@tanstack/react-query';

export function useRefreshAggregatedRule() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ['aggregated-rule'] });
}
